<template>
  <div class="user-profile with-header">
    <header-view />
    <div class="row">
      <h4>Display Name</h4>
      <input v-model="displayName" placeholder="eg: Jerry 🕵🏻‍♂️" type="text" />
    </div>
    <div class="row">
      <h4>Email</h4><span> {{ email }}</span>
    </div>
    <div class="row">
      <h4>Password</h4><span><a href="#" @click.prevent="resetPassword">Reset Password</a></span>
    </div>
    <div class="row">
      <h4>Organization</h4>
      <input v-model="userProfile['organization']" placeholder="eg: Philadelphia Federation of Teachers" type="text" />
    </div>
    <div class="row">
      <h4>Profile Image</h4>
      <div v-if="photoURL" id="new-images">
        <img :src="photoURL" />
      </div>
      <div style="margin-bottom: 10px;">
        <span v-for="image in images" v-bind:key="image['storageName']" >
          <img v-bind:key="image['storageName']" :src="image.dataUrl">
        </span>
        <button class="btn sml" @click="deleteImage">Delete Image</button>
    
      </div>
      
      <input type="file" ref="fileInput" accept="image/*" value="Choose Image" @change="onFilePicked"/>
      </div>
    <div class="row">
      <button class="btn secondary" @click="save">Save</button>
    </div>
    <center>Made with ❤️ in Philadelphia</center>
  </div>
</template>
<script>
import database from '@/api/database.js'
import HeaderView from '@/components/HeaderView.vue'
import firebase from '@firebase/app'
import '@firebase/auth'

export default {
  name: 'User',
  components: {
    HeaderView
  },
  data () {
    return {
      displayName: undefined,
      photoURL: undefined,
      newPhotoURL: undefined,
      email: undefined,
      images: [],
      user: undefined,
      userProfile: {}
    }
  },
  mounted () {
    database.getCurrentUserAndProfile().then(userAndProfile => {
      this.user = userAndProfile.user
      this.userProfile = userAndProfile.profile

      this.displayName = this.user.displayName
      this.photoURL = this.user.photoURL
      this.email = this.user.email
    })
  },
  methods: {
    resetPassword () {
      firebase.auth().sendPasswordResetEmail(this.email).then(
        () => {
          alert('Password reset email sent to: ' + this.email)
        },
        (error) => {
          alert(error.message)
        }
      )
    },
    onFilePicked (event) {
      Object.values(event.target.files).forEach(file => {
        let image = database.assembleImage(file)
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          image.dataUrl = fileReader.result
          database.saveImage(image).then(imageWith => {
            this.newPhotoURL = imageWith.downloadUrl 
            this.images.splice(0,1,image)
          })
        })
        fileReader.readAsDataURL(file)
      })
      event.srcElement.value = ''
    },
    deleteImage(event) {
      database.deleteUserPhotoURL(this.user).then(() => {
        this.photoURL = ''
      })
    },
    save(event) {
      const photoURL = this.newPhotoURL ? this.newPhotoURL : this.photoURL
      database.updateCurrentUserAndProfile (this.displayName, photoURL, this.userProfile).then(() => {
        this.images.pop()
        this.photoURL = photoURL
      })
    }
  }
}
</script>

<style scoped>

.with-header {
  padding: 60px 20px 0;
  position: relative;
}

input[type="text"] {
  border: 1px solid #999;
  height: 2.5rem;
  font-size: 1rem;
  padding-left: 1rem;
  border-radius: 5px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
h4 {
  margin-bottom: 10px;
  font-size: 15px;
}
.row {
  margin-bottom: 30px;
}
@media only screen and (min-width: 680px) {  

  input[type="text"] {
    width: auto;
  }
  .with-header {
    padding: 60px 40px 0;
    position: relative;
  }
}
img {
  height: 144px;
  width: 144px;
  clip-path: circle(72px at center);
  animation: fadein 3s;
}
@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

</style>